import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function CircleButton(props) {
  /* eslint-disable */

  const { circleButtonOverride = {} } = props;

  const { getKioskTheme } = useContext(SocketIOContext);

  const kiosktheme = getKioskTheme();

  const ColorBUttonStyle = {
    borderRadius: "50%",
    //fontSize: "clamp(18px, 2.4vi, 36px)",
    //fontSize: "clamp(9px, 2.4vi, 36px)",
    fontSize: "clamp(4.5px, 4vh, 36px)",
    padding: "2vh",
    height: "clamp(12px, 11.5vmin, 100px)",
    width: "clamp(12px, 11.5vmin, 100px)",
    // height: "clamp(12px, 14.5vmin, 100px)",
    // width: "clamp(12px, 14.5vmin, 100px)",
    minWidth: "12px",
    backgroundColor: props.color ? undefined : kiosktheme.buttonsBGColor,
    color: props.color ? undefined : kiosktheme.buttonsTextColor,
    ...circleButtonOverride
  };

  const ColorButton = styled(Button)(ColorBUttonStyle);
  /* eslint-enable */

  console.log("CIRCULEBUTTON", ColorBUttonStyle);

  return (
    <ColorButton
      variant="contained"
      color={props.color}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </ColorButton>
  );
}

export default CircleButton;
